
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import * as queryString from 'query-string'

export default {
name: 'TabbarView',
components: {
Tabbar,
TabbarItem,
},
methods: {
isCurrent(name, query) {
if (name === 'match-list') {
return this.$route.query.isOversea === query.isOversea
}
return this.$route.name === name
},

deletediv() {
this.$refs.downloaddivref.parentNode.removeChild(this.$refs.downloaddivref)
},
},
mounted() {
const sid = queryString.parse(window.location.search).sid
if (sid) {
this.$refs.downloaddivref.style.display = 'none'
}
},
create() {
},
}



// WEBPACK FOOTER //
// ./client/TabbarView.vue